import React from 'react';
import { useNavigate } from 'react-router-dom';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import './ProgramDetail.css';

const MobileComputerCamp = () => {
    useScrollAnimation();
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate('/programs/technology');
    };

    return (
        <div className="program-detail-page">
            <div className="program-hero">
                <div className="container">
                    <button onClick={handleBackClick} className="back-link">
                        <i className="fas fa-arrow-left"></i> Back to Technology Program
                    </button>
                    <div className="program-hero-content">
                        <div className="program-icon-hero">
                            <i className="fas fa-laptop-mobile"></i> 
                        </div>
                        <h1>Mobile Computer Camp</h1>
                        <p className="program-tagline">Bringing digital literacy directly to rural doorsteps</p>
                    </div>
                </div>
            </div>

            <div className="program-content">
                <div className="container">
                    <section className="program-section scroll-animate">
                        <h2>About Mobile Computer Camp</h2>
                        <p>Our Mobile Computer Camp is an innovative initiative that brings computer education directly to remote villages and rural areas where access to technology is limited. We believe geography should not be a barrier to digital literacy.</p>
                        <p>Equipped with portable computers, projectors, and internet connectivity, our mobile units travel to different villages, setting up temporary computer labs in community centers, schools, or open spaces to provide hands-on training.</p>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Key Features</h2>
                        <div className="achievements-grid">
                            <div className="achievement-card">
                                <div className="achievement-number">15+</div>
                                <div className="achievement-label">Villages Covered</div>
                                <p>Regular visits to remote locations</p>
                            </div>
                            <div className="achievement-card">
                                <div className="achievement-number">200+</div>
                                <div className="achievement-label">Students per Camp</div>
                                <p>Trained in each village visit</p>
                            </div>
                            <div className="achievement-card">
                                <div className="achievement-number">30</div>
                                <div className="achievement-label">Laptops Available</div>
                                <p>Portable training equipment</p>
                            </div>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>What We Teach</h2>
                        <div className="features-list">
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Computer Basics</h3>
                                    <p>Introduction to computers, keyboard, mouse, and basic operations</p>
                                </div>
                            </div>
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Digital Literacy</h3>
                                    <p>Understanding the digital world, internet, and online safety</p>
                                </div>
                            </div>
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>MS Office Basics</h3>
                                    <p>Introduction to Word, Excel, and PowerPoint</p>
                                </div>
                            </div>
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Email & Communication</h3>
                                    <p>Setting up email accounts and online communication</p>
                                </div>
                            </div>
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Internet Browsing</h3>
                                    <p>How to search for information and use online resources</p>
                                </div>
                            </div>
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Government Services</h3>
                                    <p>Accessing online government portals and services</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Camp Schedule</h2>
                        <div className="activities-timeline">
                            <div className="activity">
                                <div className="activity-day">Week 1</div>
                                <div className="activity-content">
                                    <h3>Setup & Introduction</h3>
                                    <p>Camp setup in village, basic computer introduction and demonstrations</p>
                                </div>
                            </div>
                            <div className="activity">
                                <div className="activity-day">Weeks 2-3</div>
                                <div className="activity-content">
                                    <h3>Hands-on Training</h3>
                                    <p>Daily practical sessions with computers, guided exercises and projects</p>
                                </div>
                            </div>
                            <div className="activity">
                                <div className="activity-day">Week 4</div>
                                <div className="activity-content">
                                    <h3>Assessment & Closure</h3>
                                    <p>Skills assessment, certificate distribution, and next camp planning</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Mobile Camp Equipment</h2>
                        <div className="menu-grid">
                            <div className="menu-item">
                                <h3>Portable Laptops</h3>
                                <p>30 laptops with latest software installed</p>
                            </div>
                            <div className="menu-item">
                                <h3>Mobile Internet</h3>
                                <p>4G connectivity for online demonstrations</p>
                            </div>
                            <div className="menu-item">
                                <h3>Power Backup</h3>
                                <p>Generators and UPS for uninterrupted training</p>
                            </div>
                            <div className="menu-item">
                                <h3>Training Materials</h3>
                                <p>Books, guides, and practice worksheets</p>
                            </div>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Program Impact</h2>
                        <div className="impact-stats">
                            <div className="impact-item">
                                <i className="fas fa-map-marked"></i>
                                <h3>Rural Outreach</h3>
                                <p>Reaching villages with no computer training facilities</p>
                            </div>
                            <div className="impact-item">
                                <i className="fas fa-users"></i>
                                <h3>Community Empowerment</h3>
                                <p>Entire villages gaining digital awareness together</p>
                            </div>
                            <div className="impact-item">
                                <i className="fas fa-lightbulb"></i>
                                <h3>Future Opportunities</h3>
                                <p>Opening doors to online education and remote work</p>
                            </div>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Who Can Attend</h2>
                        <div className="beneficiaries-info">
                            <p>Our Mobile Computer Camps are open to everyone in the village - students, youth, adults, and seniors. We especially encourage participation from those who have never used a computer before.</p>
                            <p>No prior knowledge is required. Our trainers are experienced in teaching complete beginners and make sure everyone feels comfortable learning at their own pace.</p>
                            <p>Sessions are conducted in Tamil language to ensure clear understanding and effective learning for all participants.</p>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Success Stories</h2>
                        <div className="success-stories">
                            <div className="story-card">
                                <i className="fas fa-quote-left"></i>
                                <p>"I never imagined I would learn computers at my age. The mobile camp came to our village and now I can check my pension online!"</p>
                                <div className="story-author">- Murugan, 65, Farmer</div>
                            </div>
                            <div className="story-card">
                                <i className="fas fa-quote-left"></i>
                                <p>"After the camp, I applied for an online data entry job and got selected. Now I work from my village!"</p>
                                <div className="story-author">- Selvi, 24, Data Entry Operator</div>
                            </div>
                        </div>
                    </section>

                    <section className="program-cta scroll-animate">
                        <h2>Support Mobile Computer Camp</h2>
                        <p>Help us reach more villages and bring digital literacy to remote areas</p>
                        <div className="cta-buttons">
                            <button onClick={() => navigate('/donate')} className="btn btn-primary btn-large">Donate Now</button>
                            <button onClick={() => navigate('/contact')} className="btn btn-secondary btn-large">Request Camp in Your Village</button>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default MobileComputerCamp;
